import VueRouter from "vue-router";
import Vue from "vue";
import config from "./config";
import store from "../store";
import { initHisSsoLogin, getTokenFromUrl } from "@/services/hisSso/index.js";

//1. 安装
Vue.use(VueRouter);

//2. 创建路由对象
var router = new VueRouter(config);

// 导航守卫 拦截
router.beforeEach(async function (to, from, next) {
  console.log("to", to);
  const storeToken = localStorage.getItem("storeToken") || null;
  const urlParams = new URLSearchParams(window.location.search)

  // 公开路由放行（但 Login 页面需要检查是否有 token）
  const publicRoutes = ["Errow", "ForgotPassword", "JumpError"];
  const hasTokenInUrl = getTokenFromUrl()

  // 如果访问的是 Login 页面且有 token，则优先处理 SSO 登录
  if (to.name === 'Login' && hasTokenInUrl) {
    console.log('检测到 URL 中的 HIS SSO Token，开始自动登录...')

    try {
      // 保存跳转目标到 sessionStorage
      const originalTarget = to.query.target || to.query.redirect || urlParams.get('target');
      if (originalTarget === 'jumpModal') {
        sessionStorage.setItem('jumpTarget', 'jumpModal');
        console.log('JumpModal: 已保存跳转目标到 sessionStorage');
      }

      const ssoResult = await initHisSsoLogin()

      if (ssoResult.success) {
        console.log('HIS SSO 自动登录成功')

        // SSO 登录成功后，初始化用户信息
        await store.dispatch('getUserInfoAction').then(async (res) => {
          if (res.code === 200) {
            console.log('用户信息初始化成功')

            // 检查是否需要跳转到 JumpModal
            const jumpTarget = sessionStorage.getItem('jumpTarget');
            if (jumpTarget === 'jumpModal') {
              console.log('JumpModal: 从 sessionStorage 获取到跳转目标');
              // 外部跳转，跳转到快速问诊
              sessionStorage.removeItem('jumpTarget');
              next({
                name: 'JumpModal'
              });
            } else {
              // 正常登录，跳转到问诊中心
              next({
                name: 'ConsultationControl'
              });
            }
          } else {
            console.error('用户信息初始化失败:', res)
            next({
              name: 'Login',
              query: {
                error: '用户信息初始化失败'
              }
            })
          }
        })
        return
      } else {
        console.error('HIS SSO 自动登录失败:', ssoResult.error)
        // 如果登录失败，清除可能的临时数据并跳转到错误页面
        localStorage.removeItem('storeToken')
        localStorage.removeItem('loginTenantId')
        sessionStorage.removeItem('jumpTarget')
        next({
          name: 'JumpError',
          query: {
            type: 'sso_error',
            title: 'SSO验证失败',
            message: 'HIS单点登录验证失败，请检查网络连接或联系系统管理员',
            action: '请联系管理员或关闭页面后重试',
            details: ssoResult.error || '未知错误'
          }
        })
        return
      }
    } catch (error) {
      console.error('HIS SSO 登录流程异常:', error)
      // SSO 登录流程出现异常，跳转到错误页面
      localStorage.removeItem('storeToken')
      localStorage.removeItem('loginTenantId')
      sessionStorage.removeItem('jumpTarget')
      next({
        name: 'JumpError',
        query: {
          type: 'sso_error',
          title: 'SSO验证异常',
          message: 'HIS单点登录过程中发生异常，请稍后重试',
          action: '请刷新页面或关闭后重新打开',
          details: error.message || '网络异常或服务器错误'
        }
      })
      return
    }
  }

  // 真正的公开路由（错误页、忘记密码）直接放行
  if (publicRoutes.includes(to.name)) {
    next();
    return;
  }

  // 如果访问 Login 页面但没有 token，则放行（让用户手动登录）
  if (to.name === 'Login') {
    next();
    return;
  }

  // TODO是否开启token校验
  if (!storeToken) {
    next({ name: "Login" });
    return;
  }

  if (storeToken !== store.state.userInfo?.tokenCode) {
    // console.log("storeToken !== store.state.userInfo.token");
    store.dispatch("getUserInfoAction").then(async (res) => {
      if (res.code === 200) {
        await store.dispatch("findActive", {
          filterNavList: store.state.filterNavList,
          path: to.path,
        });
        if (to.name === "Welcome" || to.name === "ConsultationControl" || to.name === "JumpModal" || to.name === "PersonCenter" || to.name === "InpatientRecord") {
          next();
          return
        }
        if (!store.state.active) {
          next({
            name: "Errow",
          });
          return;
        }
        next();
      } else {
        next({
          name: "Login",
        });
      }
    });
    return;
  }


  store.commit("updataActive", ''); //TODO:可优化/当页面不刷新时且切换到其他没有权限的path，active还是之前的值
  if (storeToken === store.state.userInfo.tokenCode) {
    // console.log("storeToken === store.state.userInfo.token", store.state);
    await store.dispatch("findActive", {
      filterNavList: store.state.filterNavList,
      path: to.path,
    });
    if (!store.state.active && to.name !== "Welcome" && to.name !== "ConsultationControl" && to.name !== "JumpModal" && to.name !== "PersonCenter" && to.name !== "InpatientRecord") {
      console.log("前往Errow")
      next({
        name: "Errow",
      });
      return;
    }
    next();
  }
});

export default router;
